import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import { ToastProvider } from "react-toast-notifications";
import './style.css'
import Home from './views/home'



const App = () => {
  return (
    <Router>
      <ToastProvider>
        <div>
          <Route component={Home} exact path="/" />
        </div>
      </ToastProvider>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
